const slideshow = document.querySelector('.custom-home-slideshow .slideshow');

if (slideshow) {
  const slides = slideshow.querySelectorAll('.slideshow__slide');

  let currentSlide = 0;
  let startX = 0;
  let endX = 0;

  const slideInterval = 5000;

  let autoplayTimer;
  let isHovered = false;

  function setSlide(index) {
    slides.forEach((slide, i) => {
      const active = i === index;

      slide.classList.toggle('custom-fade-active', active);

      slide.setAttribute('aria-hidden', active ? 'false' : 'true');

      const focusables = slide.querySelectorAll('a, button');

      focusables.forEach((element) => {
        if (active) {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', '-1');
        }
      });
    });
  }

  function goToNextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    setSlide(currentSlide);
  }

  function goToPreviousSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    setSlide(currentSlide);
  }

  function resetAutoplay() {
    clearInterval(autoplayTimer);

    autoplayTimer = setInterval(() => {
        if (!isHovered) {
        goToNextSlide();
        }
    }, slideInterval);
  }

  setSlide(currentSlide);

  resetAutoplay();

  slideshow.addEventListener('touchstart', (event) => {
    startX = event.touches[0].clientX;
  });

  slideshow.addEventListener('touchend', (event) => {
    endX = event.changedTouches[0].clientX;

    const swipeDistance = endX - startX;

    const minimumSwipeDistance = 50;

    if (swipeDistance > minimumSwipeDistance) {
      goToPreviousSlide();
      resetAutoplay();
    }

    if (swipeDistance < -minimumSwipeDistance) {
      goToNextSlide();
      resetAutoplay();
    }
  });

  slideshow.addEventListener('mouseenter', () => {
  isHovered = true;
});

slideshow.addEventListener('mouseleave', () => {
  isHovered = false;
});
}

